import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card } from "./ui/card";
import { Scales, CaretRight } from "@phosphor-icons/react";
import api from "../lib/api";

/** Avviso in Dashboard: incarichi con sopralluoghi obbligatori (DL/CSE) non ancora registrati. */
export default function AvvisoSopralluoghi() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/dashboard/sopralluoghi-mancanti").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !data.items?.length) return null;

  return (
    <Card className="border-slate-200 shadow-none mb-6 overflow-hidden border-l-4 border-l-amber-500" data-testid="avviso-sopralluoghi">
      <div className="p-4 border-b border-slate-100 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="h-8 w-8 rounded-md bg-amber-50 text-amber-700 flex items-center justify-center shrink-0">
            <Scales size={16} />
          </div>
          <div className="min-w-0">
            <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-slate-500 mb-0.5">Obblighi di normativa</div>
            <div className="text-sm font-semibold text-slate-900">Sopralluoghi obbligatori da registrare</div>
          </div>
        </div>
        <div className="text-xs font-mono text-slate-500 shrink-0" data-testid="avviso-sopralluoghi-count">
          {data.totale_mancanti} su {data.totale_pratiche} {data.totale_pratiche === 1 ? "cantiere" : "cantieri"}
        </div>
      </div>
      <div className="divide-y divide-slate-100">
        {data.items.slice(0, 5).map((it) => (
          <Link
            key={it.pratica_id}
            to={it.url}
            className="flex items-center gap-3 p-3 hover:bg-slate-50 transition-colors group"
            data-testid={`avviso-sopralluoghi-${it.pratica_id}`}
          >
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-slate-900 truncate uppercase">{it.cliente_nome || it.titolo}</div>
              <div className="text-[11px] text-slate-500 truncate mt-0.5">
                {it.prossimi.map((p) => `${p.ruolo}: ${p.nome}`).join(" · ")}
              </div>
            </div>
            <span className="text-[10px] font-mono uppercase tracking-wider px-1.5 py-0.5 rounded border bg-amber-50 text-amber-800 border-amber-200 shrink-0">
              {it.mancanti}/{it.totale} da fare
            </span>
            <CaretRight size={12} className="text-slate-300 group-hover:text-slate-900 shrink-0" />
          </Link>
        ))}
      </div>
    </Card>
  );
}
